const config = {
    title: 'Coeus',
    feature: {
        form_entry: {
            enabled: false,
        },
        upload_manager: {
            enabled: false,
        },
        adag: {
            enabled: false,
        },
        public_access: {
            enabled: true,
        },
        sso_azure: {
            enabled: false,
        },
        footer: {
            enabled: true,
            config: {
                footerText: 'Catalyst-IT Solutions',
                links: [
                    {
                        href: 'https://catalyst-it.co.uk/privacy-policy',
                        name: 'Privacy',
                    },
                    {
                        href: 'https://catalyst-it.co.uk/bi/support',
                        name: 'Help',
                    },
                ],
            },
        },
    },
    saas_client: 'Standard', // SaaS || Standard
    user: {
        custom_fields: [],
    },
    dashboard: {
        custom: [],
    },
    page: {
        valpak_sso: {
            enabled: false,
        },
    },
    post_login_overlay: {
        enabled: false,
        overlay: 'JSROverlay',
    },
};

export default config;
